import React from "react";
import Header from "./../../components/common/header/Header";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import HomeCard from "./../../components/home-card/HomeCard";
import { Link } from "react-router-dom";
import { userSelector } from "../../hooks/store/getters";
import { useAppStore } from "../../hooks/store/useAppStore";

const homeCards = [
    {
      name: "My Tours",
      desc: "Manage your tours and scenes",
      route: "/tour-list/my-tours",
      color: "red",
    },
    {
      name: "View Tours",
      desc: "Explore the collection of Hometown tours",
      route: "/tour-list/all-tours",
      color: "blue",
    },
    {
      name: "Manage Users",
      desc: "Add or Edit Users",
      route: "/manage-users",
      color: "yellow",
      role: "ADMIN"
    },
    {
      name: "Manage Teams",
      desc: "View, Add or Edit Teams",
      route: "/manage-teams",
      color: "yellow",
      // role: "ADMIN"
    },
    {
      name: "Reports",
      desc: "View analytics, usage and reports",
      route: "/",
      color: "gray",
      role: "ADMIN"
    },
  ];

const Home = () => {

  const user = useAppStore(userSelector);

  return (
    <div>
      <Header />
      <Container className="mt-5">
        <Row>
          {homeCards.filter((card) => card.role ? card.role === user.userRole : true ).map((card, index) => {
            return (
              <Col md={6} key={index}>
                <Link to={card.route}>
                  <HomeCard card={card} ></HomeCard>
                </Link>
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
};

export default Home;
